<template>
<div>
    <div class="product__detail--logo">
        <a href="/" :title="$t('thHome')"><img src="../../common/images/common/logo2.png" alt="ARIVO" width="218" height="60"></a>
        <a href="javascript:history.back();"><img src="../../common/images/common/product_center.png" alt="Product Center" width="218" height="60"> </a>
    </div> 
    <div class="product__detail--ttl">
        <div class="sub-box">
            <strong>{{product.name}}</strong>
            <a :href="product.parameter_file" target="_blank" id="dblChoseAlert" v-html="$t('lbParameterDownload')"></a>
        </div>
    </div>
    
    <div id="Contents">
        <div class="product__detail--info">
            <div class="product__detail--show">
                <div class="swiper-container gallery-top">
                    <img src="../../common/images/common/new.png" class="ico_new">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" style="width: 100% !important; ">
                          <a href="javascript:void(0);"><img id="zoom-item1" :src="product.image1" class="slide-1"></a>
                          <img src="../../common/images/common/0.png" class="ico_angle">
                        </div>
                        <div class="swiper-slide" style="width: 100% !important; ">
                          <a href="javascript:void(0);"><img id="zoom-item2" :src="product.image2" class="slide-2"></a>
                          <img src="../../common/images/common/20.png" class="ico_angle">
                        </div>
                        <div class="swiper-slide" style="width: 100% !important; ">
                          <a href="javascript:void(0);"><img id="zoom-item3" :src="product.image2" class="slide-3"></a>
                          <img src="../../common/images/common/360.png" class="ico_angle">
                        </div>
                    </div>
                    <img id="zoom-hide" style="z-index: 99999">
                    <!-- <ul class="swiper-wrapper">
                      <li class="swiper-slide" :style="{backgroundImage:'url(' + product.image1 + ')'}"><a
                          :href="product.image1"><img src="../../common/images/common/0.png" class="ico_angle"></a></li>
                      <li class="swiper-slide" :style="{backgroundImage:'url(' + product.image2 + ')'}"><a
                          :href="product.image2"><img src="../../common/images/common/20.png" class="ico_angle"></a></li>
                      <li class="swiper-slide" :style="{backgroundImage:'url(' + product.image3 + ')'}"><a
                          :href="product.image3"><img src="../../common/images/common/360.png" class="ico_angle"></a></li>
                    </ul> -->
                </div>
                <div class="swiper-container gallery-thumbs">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" :style="{backgroundImage:'url('+thumb1+')'}"></div>
                        <div class="swiper-slide" :style="{backgroundImage:'url('+thumb2+')'}"></div>
                        <div class="swiper-slide" :style="{backgroundImage:'url('+thumb3+')'}"></div>
                    </div>
                </div>
            </div>
            <div class="product__detail--right">
                <dl>
                    <dt>{{product.name}}</dt>
                    <dd v-html="product.detail">
                    </dd>
                </dl>
                <div class="ttl" style="width: 306px; height: 34px; display: block; position: relative;" >
                  <img src="../../common/images/product/sttl06.gif" style="position: absolute;">
                  <span style="position: absolute; left: 20px; font-size: 160%; line-height: 34px;" >{{product.name}}</span>
                  </div>
                <div class="ttl">{{$t("lbFeatureBenefit")}}</div>
                    <div v-html="product.features_advantages"></div>
            </div>
        </div>

        <div class="product__detail--message">
            <div class="ttl">{{$t("lbParameter")}}</div>
                <div class="table-wrapper">
                    <table cellpadding="0" cellspacing="0" class="score-list">
                    <tr>
                    <th><img src="../../common/images/common/sun2.gif"></th>
                    <td><span>{{$t("lbDryPerformance")}}</span>
                        <div class="number">
                        <div v-bind:style="'width:'+product.dry_performance+'%;'"></div>
                        </div>
                    </td>
                    <th><img src="../../common/images/common/wet2.gif"></th>
                    <td><span>{{$t("lbWetPerformance")}}</span>
                        <div class="number">
                        <div v-bind:style="'width:'+product.wet_performance+'%;'"></div>
                        </div>
                    </td>
                    <th><img src="../../common/images/common/road2.gif"></th>
                    <td><span>{{$t("lbOffRoadPerformance")}}</span>
                        <div class="number">
                        <div v-bind:style="'width:'+product.winter_performance+'%;'"></div>
                        </div>
                    </td>
                    <th><img src="../../common/images/common/comfort2.gif"></th>
                    <td><span>{{$t("lbComfort")}}</span>
                        <div class="number">
                        <div v-bind:style="'width:'+product.comfort+'%;'"></div>
                        </div>
                    </td>
                    <th><img src="../../common/images/common/silence.png"></th>
                    <td><span>{{$t("lbQuietness")}}</span>
                        <div class="number">
                        <div v-bind:style="'width:'+product.quietness+'%;'"></div>
                        </div>
                    </td>
                    </tr>
                </table>
                </div>
        </div>

        <div class="product__detail--size">
            <div class="ttl">{{$t("tlSizesSpace")}}</div>
            <div class="table-wrapper">
                <table cellpadding="0" cellspacing="0" class="form">
                    <thead>
                        <tr>
                            <th rowspan="2" style="width: 10%;" v-html="$t('lbWeelDiameter')"></th>
                            <th rowspan="2" style="width: 8%;" v-html="$t('lbTireSize')"></th>
                            <th rowspan="2" style="width: 8%;" v-html="$t('lbLISI')"></th>
                            <th rowspan="2" style="width: 8%;" v-html="$t('lbPR')"></th>
                            <th rowspan="2" style="width: 8%;" v-html="$t('lbDepth')"></th>
                            <th rowspan="2" style="width: 8%;" v-html="$t('lbRim')"></th>
                            <th rowspan="2" style="width: 7%;" v-html="$t('lbSW')"></th>
                            <th rowspan="2" style="width: 7%;" v-html="$t('lbOW')"></th>
                            <th colspan="2" style="width: 15%;" v-html="$t('lbLoadIndex')"></th>
                            <th rowspan="2" style="width: 12%;" v-html="$t('lbMaxPressure')"></th>
                            <th rowspan="2" style="width: 8%;" v-html="$t('lbUTQG')"></th>
                            <th rowspan="2" style="width: 8%;" v-html="$t('lbSidewall')"></th>
                        </tr>
                        <tr>
                            <th style="width: 7%;" v-html="$t('lbKG')"></th>
                            <th style="width: 8%;" v-html="$t('lbLBS')"></th>
                        </tr>
                    </thead>
                    <tbody v-for="size in sizes">
                        <tr v-bind:size="size.key" class="hide-item">
                            <td class="td-size" v-bind:key="size.key">{{size.key}} ({{size.value.length}})</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr v-for="item in size.value" class="tr-detail hide" v-bind:item-key="size.key">
                            <td class="td-detail">&nbsp;</td>
                            <td>{{item.size}}</td>
                            <td>{{item.li_si}}</td>
                            <td>{{item.pr}}</td>
                            <td>{{item.depth}}</td>
                            <td>{{item.rim}}</td>
                            <td>{{item.ow}}</td>
                            <td>{{item.sw}}</td>
                            <td>{{item.load_index_kg}}</td>
                            <td>{{item.load_index_lbs}}</td>
                            <td>{{item.maximum_press}}</td>
                            <td>{{item.utqg}}</td>
                            <td>{{item.sidewall}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br>
            <p>{{$t("spSizeComment")}}</p>
        </div>

        <div class="product__detail--reviews">
            <div class="ttl">{{$t("lbProductComment")}}</div>
            <ul>
                <li v-for="comment in comments">
                    <div class="comment-left">
                        <img :src="comment.user_image"><br/>
                        <span>{{comment.user_name}}</span>
                    </div>
                    <div class="comment-right">
                        <div class="comment-body">{{comment.content}}</div>
                        <div class="comment-date">{{comment.published_date}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>
import $ from "jquery";
import _ from "lodash";
import "@/common/script/zoom.js";
import Swiper from "@/common/script/swiper.min.js";
import mediumZoom from "medium-zoom";
import Thumb1 from "@/common/images/product/0.png";
import Thumb2 from "@/common/images/product/20.png";
import Thumb3 from "@/common/images/product/360.png";
import _util from "../../utils";

// import BG1 from "@/common/images/product/img01.jpg";
// import BG2 from "@/common/images/product/img02.jpg";
// import BG3 from "@/common/images/product/img03.jpg";

$(function() {
  document.body.className = "product__detail";
  $(document).on("click", ".td-size", function() {
    var tr = $(this).closest("tr");
    let key = $(tr).attr("size");
    if (tr[0].className.indexOf("show-item") > -1) {
      tr[0].className = "hide-item";
      $('.tr-detail[item-key="' + key + '"]').addClass("hide");
      $('.tr-detail[item-key="' + key + '"]').removeClass("show");
    } else {
      tr[0].className = "show-item";
      $('.tr-detail[item-key="' + key + '"]').addClass("show");
      $('.tr-detail[item-key="' + key + '"]').removeClass("hide");
    }
  });
  $(".zoom-hide").addClass("hide");
});

import WebFooter from "components/common/footer";
//import Swiper from "swiper";
import productApi from "../../api/product-api";

export default {
  name: "ProductDetail",
  props: ["id"],
  components: {
    WebFooter
  },
  data() {
    return {
      product: {},
      sizes: [],
      comments: [],
      thumb1: Thumb1,
      thumb2: Thumb2,
      thumb3: Thumb3
      // bg1: BG1,
      // bg2: BG2,
      // bg3: BG3
    };
  },
  mounted: function() {
    var _this = this;
    $(function() {
      _this.getProductDetail(_this._props.id);
      _this.getProductSizes(_this._props.id);
      _this.getProductComments(_this._props.id);
    });

    var galleryThumbs = new Swiper(".product__detail--show .gallery-thumbs", {
      slidesPerView: 3,
      spaceBetween: 25,
      freeMode: true,
      // watchSlidesVisibility: true,
      watchSlidesProgress: true
    });
    var option = {
      spaceBetween: 0,
      thumbs: {
        swiper: galleryThumbs
      }
    };
    if(_util.isPC()){
      option.width = "477";
    }
    var galleryTop = new Swiper(".product__detail--show .gallery-top", option);

    const zoom1 = mediumZoom("#zoom-item1");
    const zoom2 = mediumZoom("#zoom-item2");
    const zoom3 = mediumZoom("#zoom-item3");
    $("#zoom-item1").click(function() {
      zoom1.open();
      $(".medium-zoom-image--opened").removeClass("slide-1").addClass("auto-width");
      // $(".medium-zoom-overlay").click(function(){
      //   zoom1.detach();
      //   zoom1.close();
      // });
    });
    // $("#zoom-item1").closed(function() {
    //   zoom1.detach();
    // });
    $("#zoom-item2").click(function() {
      zoom2.open();
       $(".medium-zoom-image--opened").removeClass("slide-2").addClass("auto-width");
      // $(".medium-zoom-overlay").click(function(){
      //   zoom2.detach();
      //   zoom2.close();
      // });
    });
    // $("#zoom-item2").closed(function() {
    //   zoom2.detach();
    // });
    $("#zoom-item3").click(function() {
      zoom3.open();
       $(".medium-zoom-image--opened").removeClass("slide-3").addClass("auto-width");
      // $(".medium-zoom-overlay").click(function(){
      //   zoom3.detach();
      //   zoom3.close();
      // });
    });
    // $("#zoom-item3").closed(function() {
    //   zoom3.detach();
    // });
  },
  methods: {
    getProductDetail(id) {
      var _this = this;
      productApi.getProductDetail(
        id,
        function(response) {
          _this.product = response;
          document
            .getElementById("metaKeyword")
            .setAttribute("content", _this.product.seo);
          document
            .getElementById("metaDescription")
            .setAttribute("content", _this.product.seo_description);
        },
        function(error) {
          console.error(error);
        }
      );
    },
    getProductSizes(id) {
      let _this = this;
      productApi.getProductSizes(
        id,
        function(response) {
          let sizeUnGroup = response;
          let sizeGroupByDiameter = _.groupBy(sizeUnGroup, "wheel_diameter");
          for (var key in sizeGroupByDiameter) {
            if (!sizeGroupByDiameter.hasOwnProperty(key)) {
              containue;
            }

            let item = {};
            item.key = key;
            item.value = sizeGroupByDiameter[key];
            _this.sizes.push(item);
          }
        },
        function(error) {
          console.error(error);
        }
      );
    },
    getProductComments(id) {
      let _this = this;
      productApi.getProductComments(
        id,
        function(response) {
          if (response.data && response.data.length > 0) {
            _this.comments = response.data;
          }
        },
        function(error) {
          console.error(error);
        }
      );
    }
  }
};
</script>
<style>
@import "swiper/dist/css/swiper.min.css";
.slide-1{
  height: 100%; 
  padding: 0px 25%;
}
.slide-2{
  height: 100%; 
  padding: 0px 10%;
}
.slide-3{
  height: 100%; 
  padding: 0px 15%;
}
.auto-width{
  width: auto !important;
}
.td-size {
  cursor: pointer;
  padding-left: 30px !important;
}
.hide {
  display: none;
}
.show {
  display: table-row;
}
.show-item {
  background-image: url(./../../common/images/common/collapse.png);
  background-repeat: no-repeat;
  background-position: 10px center;
}
.hide-item {
  background-repeat: no-repeat;
  background-position: 10px center;
  background-image: url(./../../common/images/common/expand.png);
}
.swiper-container {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.gallery-top {
  height: 80%;
  width: 100%;
}
.gallery-thumbs {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-thumb-active {
  opacity: 1;
}
.medium-zoom-overlay {
  background-color: black !important;
  z-index: 9;
}
.medium-zoom-image {
  z-index: 10;
}
table tr td {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/product/productdetail.vue